import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";

interface IProps extends RouteComponentProps {
	loggedIn: boolean;
}

const LazyHoard = lazy(() => import(/* webpackChunkName: "Hoard" */ "./Hoard"));

const HoardPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, path } = props;

	if (!loggedIn) {
		return <></>;
	}

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyHoard />
	</ErrorBoundary>;
};

export default HoardPage;